export const objectEntry = (obj) => {
  const [key, value] = Object.entries(obj)[0];
  return [key, value];
};
